import { withStyles } from '@material-ui/core/styles';
import type { TablePaginationProps } from '@material-ui/core/TablePagination';
import TablePagination from '@material-ui/core/TablePagination';
import type { CSSProperties } from 'react';
import React, { Component } from 'react';

import CustomPagination from './components/CustomPagination';

const styles = withStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  toolbar: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: 'auto',
      padding: 0,
      margin: 0,
    },
  },
  caption: {
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
    },
  },
  select: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 8px',
    },
  },
}));

interface IProps {
  disabled?: boolean;
  onChangePagination?: (page: number, size: number) => void;
}

class MyTablePagination extends Component<IProps & TablePaginationProps, {}> {
  static defaultProps: Partial<IProps & TablePaginationProps> = {
    labelRowsPerPage: 'Itens por página:',
    labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
    rowsPerPageOptions: [10, 20, 30, 40],
  };

  style: CSSProperties = { display: 'flex', justifyContent: 'center ' };
  disabledStyle: CSSProperties = { ...this.style, opacity: 0.7, pointerEvents: 'none' };

  onChangePagination = (page: number, size: number = this.props.rowsPerPage) => {
    this.props.onChangePagination?.(page, size);
  };

  onPageChange = (event: any, page: number) => {
    this.onChangePagination(page + 1);
    this.props.onPageChange?.(event, page);
  };

  onChangeRowsPerPage = (event: any) => {
    this.onChangePagination(this.props.page + 1, Number(event.target.value));
    this.props.onChangeRowsPerPage?.(event);
  };

  get styleContainer() {
    if (!this.props.disabled) {
      return this.style;
    }

    return this.disabledStyle;
  }

  render() {
    const { classes, rowsPerPage, count, page, labelDisplayedRows, labelRowsPerPage, rowsPerPageOptions } = this.props;

    if (!count) {
      return null;
    }

    return (
      <div style={this.styleContainer}>
        <TablePagination
          rowsPerPage={rowsPerPage}
          count={count}
          page={page}
          labelDisplayedRows={labelDisplayedRows}
          labelRowsPerPage={labelRowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          ActionsComponent={CustomPagination}
          onChangeRowsPerPage={this.onChangeRowsPerPage}
          onPageChange={this.onPageChange}
          component='div'
          classes={{
            root: classes.root,
            toolbar: classes.toolbar,
            caption: classes.caption,
            selectRoot: classes.select,
          }}
        />
      </div>
    );
  }
}

export default styles(MyTablePagination);
